import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../../basecomp/components/provider/ToastProvider";
import * as XLSX from "xlsx";
import {
  uploadAutomationData,
  processAutomationData,
  processMrpSettingBatch,
  downloadProcessedData,
  checkCountData,
  checkAndDeleteFileFromS3,
  // translateRecords,
  // getAllLanguages,
} from "../model/mrpProcessingModel";
// import {
//   uploadAutomationData,
//   processAutomationData,
//   downloadProcessedData,
//   checkCountData,
//   checkAndDeleteFileFromS3,
//   // translateRecords,
//   // getAllLanguages,
// } from "../model/mrpProcessingModel";
 
import sampleFileUrl from "../sample_file/mrp_sample.xlsx";
 
import { v4 as uuidv4 } from "uuid";
 
const DataProcessingVM = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleToastOpen } = useToast();
  const uploadIntervalRef = useRef(null);
  const translationCheckIntervalRef = useRef(null);
  const translationProgressIntervalRef = useRef(null);
  const [duplicateDetails, setDuplicateDetails] = useState(null);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
 
  const [activeStep, setActiveStep] = useState(1);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingComplete, setIsProcessingComplete] = useState(false);
  const [selectedModel, setSelectedModel] = useState("");
  const [processingProgress, setProcessingProgress] = useState(0);
  const [processingStats, setProcessingStats] = useState({
    processed: 0,
    total: 5000,
    timeElapsed: "0:00",
    timeRemaining: "4:30",
  });
  const [isMobile, setIsMobile] = useState(false);
  const [uniqueRecords, setUniqueRecords] = useState(0);
  const [processRecords, setProcessRecords] = useState(0);
  const [batchId, setBatchId] = useState(null);
  const [reviewCount, setReviewCount] = useState(0);
  const [cOpen, setCOpen] = useState(false);
  const [errorDetails, setErrorDetails] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [currentFolderId, setCurrentFolderId] = useState(null);
  const [data, setData] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [checkCountTimer, setCheckCountTimer] = useState(null);
  const [modelOptions, setModelOptions] = useState([]);
  const [isLoadingOptions, setIsLoadingOptions] = useState(false);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [managedLanguages, setManagedLanguages] = useState([]);
  const [availableLanguages, setAvailableLanguages] = useState([]);
  const [isTranslating, setIsTranslating] = useState(false);
  const [translationProgress, setTranslationProgress] = useState(0);
  const [translationComplete, setTranslationComplete] = useState(false);
  const [translationStats, setTranslationStats] = useState({
    processed: 0,
    total: 0,
    percentage: 0,
  });
  const [showTranslationModal, setShowTranslationModal] = useState(false);
  const [allLanguagesFromApi, setAllLanguagesFromApi] = useState([]);
 
  const selectedTool = "MRP_TOOL";
 
  const HARDCODED_DEFAULT_LANGUAGES = [
    { id: 999001, name: "FRENCH", isHardcoded: true },
    { id: 999002, name: "SPANISH", isHardcoded: true },
    { id: 999003, name: "PORTUGUESE", isHardcoded: true },
    { id: 999004, name: "CROATIAN", isHardcoded: true },
  ];
 
  const DEFAULT_LANGUAGE_IDS = [999001, 999002, 999003, 999004];
  const MAX_TOTAL_LANGUAGES = 6;
  const STORAGE_KEY = "mrp_tool_additional_languages";
 
  const calculateTimings = (recordCount) => {
    const count = recordCount || 0;
 
    let translationDuration, checkCountDuration;
 
    if (count <= 500) {
      translationDuration = 1 * 60 * 1000;
      checkCountDuration = 10 * 1000;
    } else if (count <= 1000) {
      translationDuration = 1.5 * 60 * 1000;
      checkCountDuration = 15 * 1000;
    } else if (count <= 2500) {
      translationDuration = 2 * 60 * 1000;
      checkCountDuration = 20 * 1000;
    } else if (count <= 5000) {
      translationDuration = 3 * 60 * 1000;
      checkCountDuration = 25 * 1000;
    } else if (count <= 10000) {
      translationDuration = 4 * 60 * 1000;
      checkCountDuration = 30 * 1000;
    } else if (count <= 15000) {
      translationDuration = 5 * 60 * 1000;
      checkCountDuration = 30 * 1000;
    } else if (count <= 20000) {
      translationDuration = 6 * 60 * 1000;
      checkCountDuration = 40 * 1000;
    } else {
      translationDuration = 7 * 60 * 1000;
      checkCountDuration = 50 * 1000;
    }
 
    const totalDuration = translationDuration + checkCountDuration;
 
    return {
      translationDuration,
      checkCountDuration,
      totalDuration,
    };
  };
 
  const loadAdditionalLanguagesFromStorage = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (error) {
      console.error("Error loading from localStorage:", error);
    }
    return [];
  };
 
  const saveAdditionalLanguagesToStorage = (languageIds) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(languageIds));
    } catch (error) {
      console.error("Error saving to localStorage:", error);
    }
  };
 
  // useEffect(() => {
  //   const loadAllLanguages = async () => {
  //     setIsLoadingOptions(true);
  //     try {
  //       let apiLanguages = [];
  //       try {
  //         apiLanguages = await getAllLanguages();
  //       } catch (error) {
  //         console.error("Error fetching languages from API:", error);
  //         apiLanguages = [];
  //       }
 
  //       setAllLanguagesFromApi(apiLanguages);
 
  //       const storedAdditionalLanguageIds =
  //         loadAdditionalLanguagesFromStorage();
 
  //       const additionalLanguages = apiLanguages.filter((lang) =>
  //         storedAdditionalLanguageIds.includes(lang.id),
  //       );
 
  //       const allSelectedLanguages = [
  //         ...HARDCODED_DEFAULT_LANGUAGES,
  //         ...additionalLanguages,
  //       ];
 
  //       setManagedLanguages(allSelectedLanguages);
  //       setModelOptions(allSelectedLanguages);
 
  //       const allSelectedIds = allSelectedLanguages.map((lang) => lang.id);
  //       const availableLangs = apiLanguages.filter(
  //         (lang) => !allSelectedIds.includes(lang.id),
  //       );
  //       setAvailableLanguages(availableLangs);
  //     } catch (error) {
  //       console.error("Error loading languages:", error);
  //       handleToastOpen("error", "Failed to load languages");
  //       setAvailableLanguages([]);
  //       setModelOptions(HARDCODED_DEFAULT_LANGUAGES);
  //       setManagedLanguages(HARDCODED_DEFAULT_LANGUAGES);
  //     } finally {
  //       setIsLoadingOptions(false);
  //     }
  //   };
 
  //   loadAllLanguages();
  // }, []);
 
    const cardData = [
    {
      header: "Unique Records",
      value: `${uniqueRecords}/${totalCount || 0}`,
      id: "unique",
    },
    {
      header: "Processed Records",
      value: `${processRecords}/${totalCount || 0}`,
      id: "process",
    },
    ...(reviewCount > 0
      ? [{ header: "Needs AI Review", value: `${reviewCount}`, id: "review" }]
      : []),
  ];
 
  // const cardData = [
  //   {
  //     header: "Unique Records",
  //     value: `${uniqueRecords}/${totalCount || 0}`,
  //     id: "unique",
  //   },
  //   {
  //     header: "Processed Records",
  //     value: `${processRecords}/${totalCount || 0}`,
  //     id: "process",
  //   },
  // ];
 
  const clearAllIntervals = () => {
    if (uploadIntervalRef.current) {
      clearInterval(uploadIntervalRef.current);
      uploadIntervalRef.current = null;
    }
 
    if (checkCountTimer) {
      clearTimeout(checkCountTimer);
      setCheckCountTimer(null);
    }
 
    if (translationCheckIntervalRef.current) {
      clearTimeout(translationCheckIntervalRef.current);
      translationCheckIntervalRef.current = null;
    }
 
    if (translationProgressIntervalRef.current) {
      cancelAnimationFrame(translationProgressIntervalRef.current);
      translationProgressIntervalRef.current = null;
    }
  };
 
  const handleManageLanguages = () => {
    setShowLanguageModal(true);
  };
 
  const isDefaultLanguage = (languageId) => {
    return DEFAULT_LANGUAGE_IDS.includes(languageId);
  };
 
  const handleAddLanguage = (languageId) => {
    if (managedLanguages.length >= MAX_TOTAL_LANGUAGES) {
      handleToastOpen(
        "error",
        `You can only have up to ${MAX_TOTAL_LANGUAGES} languages in total`,
      );
      return;
    }
 
    const newLanguage = allLanguagesFromApi.find(
      (lang) => lang.id === parseInt(languageId),
    );
 
    if (
      newLanguage &&
      !managedLanguages.some((lang) => lang.id === newLanguage.id)
    ) {
      const updatedLanguages = [...managedLanguages, newLanguage];
      setManagedLanguages(updatedLanguages);
      setModelOptions(updatedLanguages);
 
      const additionalLanguageIds = updatedLanguages
        .filter((lang) => !isDefaultLanguage(lang.id))
        .map((lang) => lang.id);
 
      saveAdditionalLanguagesToStorage(additionalLanguageIds);
 
      const updatedAvailableLanguages = availableLanguages.filter(
        (lang) => lang.id !== newLanguage.id,
      );
      setAvailableLanguages(updatedAvailableLanguages);
 
      handleToastOpen("success", `${newLanguage.name} added successfully`);
    }
  };
 
  const handleDeleteLanguage = (languageId) => {
    const languageToDelete = managedLanguages.find(
      (lang) => lang.id === parseInt(languageId),
    );
 
    if (languageToDelete && isDefaultLanguage(languageToDelete.id)) {
      handleToastOpen("error", "Default languages cannot be deleted");
      return;
    }
 
    const updatedLanguages = managedLanguages.filter(
      (lang) => lang.id !== parseInt(languageId),
    );
    setManagedLanguages(updatedLanguages);
    setModelOptions(updatedLanguages);
 
    const additionalLanguageIds = updatedLanguages
      .filter((lang) => !isDefaultLanguage(lang.id))
      .map((lang) => lang.id);
 
    saveAdditionalLanguagesToStorage(additionalLanguageIds);
 
    if (languageToDelete && !isDefaultLanguage(languageToDelete.id)) {
      const updatedAvailableLanguages = [
        ...availableLanguages,
        languageToDelete,
      ].sort((a, b) => a.name.localeCompare(b.name));
      setAvailableLanguages(updatedAvailableLanguages);
    }
 
    if (languageToDelete) {
      handleToastOpen(
        "success",
        `${languageToDelete.name} deleted successfully`,
      );
    }
  };
 
  const handleFileUpload = async () => {
    try {
      clearAllIntervals();
 
      setIsUploading(true);
      setUploadProgress(0);
      await new Promise((resolve) => setTimeout(resolve, 500));
 
      const startTime = Date.now();
 
      let uploadDuration;
      if (totalCount <= 1000) {
        uploadDuration = 10000;
      } else if (totalCount <= 5000) {
        uploadDuration = 20000;
      } else if (totalCount <= 10000) {
        uploadDuration = 30000;
      } else if (totalCount <= 15000) {
        uploadDuration = 40000;
      } else {
        uploadDuration = 50000;
      }
 
      uploadIntervalRef.current = setInterval(() => {
        const elapsedMs = Date.now() - startTime;
        const progressPercentage = Math.min(
          90,
          (elapsedMs / uploadDuration) * 100,
        );
        setUploadProgress((prevProgress) =>
          Math.max(prevProgress, Math.floor(progressPercentage)),
        );
 
        const elapsedSeconds = Math.floor(elapsedMs / 1000);
        const elapsedMinutes = Math.floor(elapsedSeconds / 60);
        const remainingSeconds = Math.floor(
          (uploadDuration - elapsedMs) / 1000,
        );
        const remainingMinutes = Math.floor(remainingSeconds / 60);
 
        setProcessingStats({
          processed: Math.floor((totalCount || 0) * (progressPercentage / 100)),
          total: totalCount || 0,
          timeElapsed: `${elapsedMinutes}:${(elapsedSeconds % 60).toString().padStart(2, "0")}`,
          timeRemaining: `${remainingMinutes}:${(remainingSeconds % 60).toString().padStart(2, "0")}`,
        });
      }, 800);
 
      try {
        await validateFile(selectedFile);
      } catch (validationError) {
        clearAllIntervals();
        setIsUploading(false);
        handleToastOpen("error", validationError.message || validationError);
        return;
      }
 
      let currentUniqueRecords = uniqueRecords;
      let currentTotalCount = totalCount;
 
      if (!currentUniqueRecords || currentUniqueRecords === 0) {
        try {
          currentUniqueRecords = await countUniqueRecords(selectedFile);
        } catch (error) {
          clearAllIntervals();
          setIsUploading(false);
          handleToastOpen("error", "Failed to count unique records");
          return;
        }
      }
 
      if (!currentTotalCount || currentTotalCount === 0) {
        try {
          const totalCountResult = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
              try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                  header: 1,
                });
                const rowsWithoutHeader = jsonData
                  .slice(1)
                  .filter((row) => row.length > 0);
                setTotalCount(rowsWithoutHeader.length);
                resolve(rowsWithoutHeader.length);
              } catch (error) {
                reject(error);
              }
            };
            reader.onerror = () => reject("Error reading file");
            reader.readAsArrayBuffer(selectedFile);
          });
 
          currentTotalCount = totalCountResult;
        } catch (error) {
          clearAllIntervals();
          setIsUploading(false);
          handleToastOpen("error", "Failed to calculate total record count");
          return;
        }
      }
 
      const fileArray = [selectedFile];
      const modelToUse = selectedModel;
      const batchIdToUse = uuidv4();
      setBatchId(batchIdToUse);
 
      const response = await uploadAutomationData(
        fileArray,
        selectedTool,
        modelToUse,
        currentUniqueRecords,
        currentTotalCount,
        batchIdToUse,
      );
 
      clearAllIntervals();
      setUploadProgress(100);
 
      setTimeout(() => {
        setIsUploading(false);
 
        // if (response?.status === 201) {
        //   setData(response);
        //   const folderId = response.data[0].folderId;
        //   setCurrentFolderId(folderId);
        //   const currentElapsedTime = processingStats.timeElapsed || "0:00";
 
        //   setProcessingStats({
        //     processed: totalCount,
        //     total: totalCount,
        //     timeElapsed: currentElapsedTime,
        //     timeRemaining: "0:00"
        //   });
 
        //   handleToastOpen("success", "File Uploaded Successfully");
        //   setFileUploaded(true);
        //   setActiveStep(2);
        if (response?.status === 201) {
          setData(response);
          const folderId = response.data[0].folderId;
          const currentElapsedTime = processingStats.timeElapsed || "0:00";
 
          setProcessingStats({
            processed: totalCount,
            total: totalCount,
            timeElapsed: currentElapsedTime,
            timeRemaining: "0:00",
          });
 
          // ── duplicate check ──────────────────────────────────────────
          const dupCheck = response.apiResponse?.duplicate_check;
          if (dupCheck?.has_duplicates) {
            setDuplicateDetails(dupCheck);
            setShowDuplicateModal(true);
          }
          // ─────────────────────────────────────────────────────────────
 
          handleToastOpen("success", "File Uploaded Successfully");
          setFileUploaded(true);
          setActiveStep(2);
        } else {
          handleToastOpen(
            "error",
            "Upload failed with status: " + (response?.status || "unknown"),
          );
        }
      }, 500);
    } catch (error) {
      clearAllIntervals();
 
      let errorDetails = {};
 
      const errorData =
        error &&
        error.message &&
        (error.missing_columns || error.expected_columns || error.found_columns)
          ? error
          : error.response && error.response.data && error.response.data.detail
            ? error.response.data.detail
            : null;
 
      if (errorData) {
        const tryDecodeBase64 = (str) => {
          if (typeof str !== "string") return str;
 
          if (/^[A-Za-z0-9+/=]+$/.test(str) && str.length > 20) {
            try {
              const decoded = atob(str);
              return decoded;
            } catch (e) {
              return str;
            }
          }
          return str;
        };
 
        const processArray = (arr) => {
          if (!Array.isArray(arr)) return [];
          return arr.map((item) => tryDecodeBase64(item));
        };
 
        errorDetails = {
          message: errorData.message || "Invalid file format",
          missing_columns: processArray(errorData.missing_columns || []),
          expected_columns: processArray(errorData.expected_columns || []),
          extra_columns: processArray(errorData.extra_columns || []),
          found_columns: processArray(errorData.found_columns || []),
        };
 
        setErrorDetails(errorDetails);
        setShowErrorModal(true);
      } else {
        const errorMessage =
          error.message || "Something went wrong, please try again later!";
        handleToastOpen("error", errorMessage);
      }
      setIsUploading(false);
    }
  };
 
  const handleStartProcessing = async () => {
  try {
    const params = new URLSearchParams(location.search);
    const urlBatchId = params.get("batchId");
    const urlTotalRecords = params.get("totalRecords");
    const urlToBeProcessed = params.get("toBeProcessed") === "true";
 
    clearAllIntervals();
    setIsProcessing(true);
    setProcessingProgress(0);
 
    const recordCount =
      totalCount || (urlTotalRecords ? parseInt(urlTotalRecords, 10) : 0);
 
    setProcessingStats({
      processed: 0,
      total: recordCount,
      timeElapsed: "0:00",
      timeRemaining: "calculating...",
    });
 
    const startTime = Date.now();
 
    const elapsedTimer = setInterval(() => {
      const elapsedMs = Date.now() - startTime;
      const elapsedMinutes = Math.floor(elapsedMs / 60000);
      const elapsedSeconds = Math.floor((elapsedMs % 60000) / 1000);
      setProcessingStats((prev) => ({
        ...prev,
        timeElapsed: `${elapsedMinutes}:${elapsedSeconds < 10 ? "0" + elapsedSeconds : elapsedSeconds}`,
      }));
    }, 1000);
    uploadIntervalRef.current = elapsedTimer;
 
    const processingBatchIdToUse =
      batchId || (urlToBeProcessed ? urlBatchId : null) || uuidv4();
    setBatchId(processingBatchIdToUse);
 
    try {
      const result = await processMrpSettingBatch(
        processingBatchIdToUse,
        (progress) => {
          if (progress.status === "chunk_completed") {
            setProcessingProgress(progress.percentComplete);
            setProcessingStats((prev) => ({
              ...prev,
              processed: Math.round((progress.percentComplete / 100) * recordCount),
              chunkInfo:
                `Chunk ${progress.chunkIndex + 1}/${progress.totalChunks} completed ` +
                `(${progress.recordsSaved} saved` +
                `${progress.recordsFailed ? `, ${progress.recordsFailed} failed` : ""})`,
            }));
          } else if (progress.status === "chunk_failed") {
            setProcessingStats((prev) => ({
              ...prev,
              chunkInfo: `Chunk ${progress.chunkIndex + 1}/${progress.totalChunks} failed after retries — continuing`,
            }));
          }
        },
      );
 
      clearAllIntervals();
      setProcessRecords(result.records_saved);
      setReviewCount(result.recommend_ai_review_count || 0);
      setProcessingProgress(100);
      setProcessingStats((prev) => ({
        ...prev,
        processed: result.records_saved,
        timeRemaining: "0:00",
      }));
 
      setTimeout(() => {
        setIsProcessing(false);
        setIsProcessingComplete(true);
        setActiveStep(3);
 
        if (result.status === "completed_with_errors") {
          handleToastOpen(
            "warning",
            `Processing finished, but ${result.failed_chunk_indexes.length} chunk(s) ` +
            `couldn't complete after retries (chunk indexes: ${result.failed_chunk_indexes.join(", ")}). ` +
            `${result.records_saved} of ${result.total_records} records were saved.`,
          );
        } else {
          handleToastOpen("success", "Processing complete!");
        }
      }, 500);
    } catch (processError) {
      console.error("Processing error:", processError);
      clearAllIntervals();
      setIsProcessing(false);
      handleToastOpen(
        "error",
        processError.message || "Error during processing",
      );
    }
 
    setFileUploaded(false);
  } catch (error) {
    console.error("Processing error:", error);
    clearAllIntervals();
    setIsProcessing(false);
    handleToastOpen("error", error.message || "Error during processing");
  }
};
 
 
  useEffect(() => {
    return () => {
      clearAllIntervals();
    };
  }, []);
 
 
 
  const handleDownload = async () => {
    if (!isProcessingComplete) return;
 
    setCOpen(true);
    try {
      // downloadProcessedData now handles everything including
      // triggering the browser download internally
      const { filename } = await downloadProcessedData(
        selectedTool,
        batchId,
        selectedModel,
        translationComplete,
      );
 
      handleToastOpen("success", `Downloaded: ${filename}`);
 
      setTimeout(() => {
        handleViewHistory();
      }, 500);
    } catch (error) {
      if (error.name !== "AbortError") {
        handleToastOpen(
          "error",
          "Download failed: " + (error.message || "Unknown error"),
        );
      }
    } finally {
      setCOpen(false);
    }
  };
 
  const handleReset = () => {
    const params = new URLSearchParams(location.search);
    const urlToBeProcessed = params.get("toBeProcessed") === "true";
 
    if (urlToBeProcessed) {
      navigate(-1);
    } else {
      setSelectedFile(null);
      setFileUploaded(false);
      setIsProcessingComplete(false);
      setActiveStep(1);
      setUniqueRecords(0);
      setProcessRecords(0);
      setTotalCount(0);
      setIsTranslating(false);
      setTranslationComplete(false);
      setTranslationProgress(0);
      setShowTranslationModal(false);
      handleToastOpen("Process reset", "");
    }
  };
 
  const handleModelChange = (event) => {
    setSelectedModel(event);
  };
 
  const handleViewHistory = () => {
    navigate(
      `/mrp_tool/history?tool=${encodeURIComponent(selectedTool)}`,
    );
  };
 
  const countUniqueRecords = async (file) => {
    if (!file) {
      return 0;
    }
 
    const fileObject = Array.isArray(file) ? file[0] : file;
 
    if (!fileObject) {
      return 0;
    }
 
    const fileType = fileObject.type;
    const fileName = fileObject.name || "";
 
    const isExcel =
      fileType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      fileName.endsWith(".xlsx") ||
      fileName.endsWith(".xls");
 
    if (!isExcel) {
      return 0;
    }
 
    const reader = new FileReader();
 
    return new Promise((resolve, reject) => {
      reader.onload = function (event) {
        try {
          const workbook = XLSX.read(event.target.result, {
            type: "array",
            cellDates: true,
          });
 
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
 
          const data = XLSX.utils.sheet_to_json(sheet, {
            defval: null,
            blankrows: false,
          });
 
          let uniqueCount = data.length > 0 ? data.length : 0;
 
          setUniqueRecords(uniqueCount);
          resolve(uniqueCount);
        } catch (error) {
          console.error("Error processing file:", error);
          reject(error);
        }
      };
 
      reader.onerror = function () {
        reject("FileReader error");
      };
 
      try {
        reader.readAsArrayBuffer(fileObject);
      } catch (error) {
        reject(error);
      }
    });
  };
 
  const handleFileSelection = async (files) => {
    if (!files || files.length === 0) return;
 
    const file = files[0];
 
    const validMimeTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    const validExtensions = ["xlsx", "xls"];
    const fileExtension = file.name.split(".").pop().toLowerCase();
 
    if (
      !validMimeTypes.includes(file.type) ||
      !validExtensions.includes(fileExtension)
    ) {
      handleToastOpen(
        "error",
        "Invalid file type. Please upload an Excel (.xlsx or .xls) file.",
      );
      return;
    }
 
    setErrorDetails(null);
    setShowErrorModal(false);
 
    setSelectedFile(file);
    setCOpen(true);
 
    try {
      const recordLimit = 15000;
 
      const reader = new FileReader();
 
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheet = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheet];
 
          const allRows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          const rowsWithoutHeader = allRows
            .slice(1)
            .filter((row) => row.length > 0);
          const recordCount = rowsWithoutHeader.length;
 
          if (recordCount > recordLimit) {
            setSelectedFile("");
            setTotalCount(0);
            handleToastOpen(
              "error",
              `File contains ${recordCount} records. Maximum allowed is ${recordLimit}.`,
            );
          } else {
            setTotalCount(recordCount);
            handleToastOpen("success", `Selected file: ${file.name}`);
          }
        } catch (err) {
          handleToastOpen("error", `Error processing file: ${err.message}`);
        } finally {
          setCOpen(false);
        }
      };
 
      reader.onerror = () => {
        handleToastOpen("error", "Error reading file.");
        setCOpen(false);
      };
 
      reader.readAsArrayBuffer(file);
    } catch (error) {
      handleToastOpen("error", error.message);
      setCOpen(false);
    }
  };
 
  const validateFile = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject("No file selected.");
        return;
      }
 
      const validMimeTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
 
      const validExtensions = ["xlsx", "xls"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
 
      if (!validMimeTypes.includes(file.type)) {
        reject(
          "Invalid file type. Please upload an Excel (.xlsx or .xls) file.",
        );
        return;
      }
 
      if (!validExtensions.includes(fileExtension)) {
        reject(
          "Invalid file extension. Please upload an Excel (.xlsx or .xls) file.",
        );
        return;
      }
 
      const recordLimit = 15000;
 
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          const recordCount = jsonData.length;
 
          if (recordCount > recordLimit) {
            reject(
              `File contains ${recordCount} records. Maximum allowed is ${recordLimit} records.`,
            );
            return;
          }
 
          resolve(null);
        } catch (error) {
          reject(`Error processing file: ${error.message}`);
        }
      };
 
      reader.onerror = () => {
        reject("Error reading file.");
      };
 
      reader.readAsArrayBuffer(file);
    });
  };
 
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
 
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
 
  const params = new URLSearchParams(location.search);
  const urlBatchId = params.get("batchId");
  const urlModelName = params.get("modelName");
  const urlTotalRecords = params.get("totalRecords")
    ? parseInt(params.get("totalRecords"), 10)
    : null;
  const urlUniqueRecords = params.get("uniqueRecords")
    ? parseInt(params.get("uniqueRecords"), 10)
    : null;
  const urlToBeProcessed = params.get("toBeProcessed") === "true";
 
  useEffect(() => {
    if (urlBatchId && urlToBeProcessed) {
      setBatchId(urlBatchId);
      setActiveStep(2);
      setFileUploaded(true);
 
      if (urlTotalRecords) {
        setTotalCount(urlTotalRecords);
      }
 
      if (urlUniqueRecords) {
        setUniqueRecords(urlUniqueRecords);
      }
 
      if (urlModelName) {
        setSelectedModel(urlModelName);
      }
 
      handleToastOpen("success", "File Retrieved Successfully");
    }
  }, []);
 
  const handleErrorDialogClose = () => {
    setShowErrorModal(false);
    setErrorDetails(null);
  };
 
  const handleRequestSample = () => {
    downloadSampleFile();
  };
 
  // const downloadSampleFile = () => {
  //   const data = [
  //     {
  //       Material: "7000000458",
  //       Pl: "",
  //       "Material Description": "Cover for odu plug 7114-0120-0110",
  //       "Long Description": "7114-0120-0110 PLASTIC COVER FOR PLUG 309.021",
  //       "Equipment Function": "SP - ELECTRICAL",
  //       "Material Criticality Indicator": "",
  //       Language: "E",
  //       "Matl Group": "EN",
  //       uom: "ISPR68",
  //       PGr: "EA",
  //       MTyp: "HWR",
  //       "Valuation class": "INBW",
  //       "Part Type Code": "3300",
  //       "Level 1": "PT113",
  //       "Level 2": "CONSUMABLES",
  //       "Level 3": "ELECTRICAL CONSUMABLES",
  //       "Level 4": "MISC. ELECTRICAL POWER CABLE COVER",
  //     },
  //     {
  //       Material: "7000001517",
  //       Pl: "",
  //       "Material Description": "15A Electrical Socket",
  //       "Long Description": "15A ELECTRICAL SOCKET SWITCH",
  //       "Equipment Function": "",
  //       "Material Criticality Indicator": "",
  //       Language: "E",
  //       "Matl Group": "EN",
  //       uom: "ISPR68",
  //       PGr: "EA",
  //       MTyp: "HWR",
  //       "Valuation class": "INBW",
  //       "Part Type Code": "3300",
  //       "Level 1": "PT113",
  //       "Level 2": "CONSUMABLES",
  //       "Level 3": "ELECTRICAL CONSUMABLES",
  //       "Level 4": "MISC. ELECTRICAL PLUG",
  //     },
  //   ];
  //   const filename = "IFS_Operations_Input_Sample.xlsx";
  //   try {
  //     const workbook = XLSX.utils.book_new();
  //     const worksheet = XLSX.utils.json_to_sheet(data);
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Sample Data");
  //     const excelBuffer = XLSX.write(workbook, {
  //       bookType: "xlsx",
  //       type: "array",
  //     });
  //     const blob = new Blob([excelBuffer], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });
  //     const url = URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = filename;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     URL.revokeObjectURL(url);
  //     handleToastOpen("success", `Sample template "${filename}" downloaded`);
  //   } catch (error) {
  //     handleToastOpen("error", "Failed to generate sample template");
  //   }
  // };
 
 
// adjust the relative path to wherever this component sits relative to src/mrp_setting/src/sample_file/
 
// const downloadSampleFile = () => {
//   const filename = "MRP_Sample_Input.xlsx";
 
//   try {
//     const link = document.createElement("a");
//     link.href = sampleFileUrl;
//     link.download = filename;
 
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
 
//     handleToastOpen("success", `Sample template "${filename}" downloaded`);
//   } catch (error) {
//     console.error("Sample file download error:", error);
//     handleToastOpen("error", "Failed to download sample template");
//   }
// };


const downloadSampleFile = () => {
  const filename = "MRP_Sample_Input.xlsx";

  // Row 1: merged banner/group headers
  const bannerRow = [
    "MATERIAL INFO", null, null, null, null, null, null,          // A1:G1
    "Storage location (SLOC)", null, null, null, null, null, null, // H1:N1
    null, null, null, null, null, null,                            // (unlabeled columns)
    "LEAD TIME", null, null,                                       // U1:W1
    "ACTUAL STOCK (MB52)", null, null, null, null,                 // X1:AB1
    "FX RATE (ZAR/USD)", 16.95, null
  ];

  // Row 2: actual column headers
  const headerRow = [
    "Material Number", "Material Description", "Material Type",
    "Category L1", "Category L2", "Category L3", "UOM",
    "0001 – Fuel (Petrol & Diesel)", "0002 – Admin and PPE",
    "0003 – Mechanical Spreader (Crane store)", "0004 – Electrical (Crane store)",
    "0005 – Straddle Store", "0006 - CVR", "0007 - Mechanical Motor (Crane store)",
    "ABC Class", "Consumption 2023", "Consumption 2024", "Consumption 2025",
    "Avg Yearly Consumption", "Avg Monthly\nConsumption",
    "Min Lead Time (Days)", "Avg Lead Time (Days)", "Max Lead Time (Days)",
    "Actual Stock (MB52)", "Stock Value ZAR (MB52)", "Unit Cost in ZAR (MB51)",
    "Stock Value USD (MB52)", "Unit Cost (USD)",
    "Used for ZAR → USD conversion in Stock Value USD (MB52) and Unit Cost (USD) columns",
    null, "Consumption 2026"
  ];

  // Row 3: sample data (Material 135256)
  const dataRow = [
    135256, "ASSEMBLY;T5616710,KALMAR S/C", "Spare parts/fuel",
    "SPARE PARTS", "MECHANICAL PARTS", "MECHANICAL PARTS", "EA",
    "", "", "", "", "X", "", "",
    "A", 160, 181, 278, 206.3, 17.1916666666667,
    1, 22, 62, 0, 0, 6353.5, 0, 374.83775811209443,
    "", null, 91
  ];

  try {
    const worksheet = XLSX.utils.aoa_to_sheet([bannerRow, headerRow, dataRow]);

    // Re-create the merges from the original banner row
    worksheet["!merges"] = [
      { s: { r: 0, c: 0 },  e: { r: 0, c: 6 } },   // A1:G1  MATERIAL INFO
      { s: { r: 0, c: 7 },  e: { r: 0, c: 13 } },  // H1:N1  Storage location (SLOC)
      { s: { r: 0, c: 20 }, e: { r: 0, c: 22 } },  // U1:W1  LEAD TIME
      { s: { r: 0, c: 23 }, e: { r: 0, c: 27 } },  // X1:AB1 ACTUAL STOCK (MB52)
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "MRP Parameters");

    XLSX.writeFile(workbook, filename);

    handleToastOpen("success", `Sample template "${filename}" downloaded`);
  } catch (error) {
    console.error("Sample file download error:", error);
    handleToastOpen("error", "Failed to download sample template");
  }
};
  const handleCloseTranslationModal = () => {
    if (!isTranslating) {
      setShowTranslationModal(false);
    }
  };
 
  return {
    activeStep,
    selectedFile,
    fileUploaded,
    isProcessing,
    isProcessingComplete,
    selectedModel,
    processingProgress,
    processingStats,
    isMobile,
    totalCount,
    isUploading,
    uploadProgress,
    batchId,
    errorDetails,
    showErrorModal,
    modelOptions,
    cardData,
    cOpen,
    isLoadingOptions,
    showLanguageModal,
    managedLanguages,
    availableLanguages,
    isTranslating,
    translationProgress,
    translationComplete,
    translationStats,
    showTranslationModal,
    setActiveStep,
    setSelectedFile,
    setFileUploaded,
    setIsProcessing,
    setIsProcessingComplete,
    setSelectedModel,
    setProcessingProgress,
    setProcessingStats,
    setCOpen,
    setShowLanguageModal,
    handleFileUpload,
    handleStartProcessing,
    handleDownload,
    handleRequestSample,
    handleReset,
    handleModelChange,
    handleViewHistory,
    handleFileSelection,
    handleErrorDialogClose,
    handleManageLanguages,
    handleAddLanguage,
    handleDeleteLanguage,
    // handleStartTranslation,
    handleCloseTranslationModal,
    clearAllIntervals,
    // ...all existing returns...
    duplicateDetails,
    showDuplicateModal,
    handleCloseDuplicateModal: () => setShowDuplicateModal(false),
  };
};
 
export default DataProcessingVM;
 
 